module.exports = __webpack_public_path__ + "static/estate-planning-quiz.cd200380.webp";